import type { Payroll } from '@/types/employee/payroll';

export const payrolls: Payroll[] = [
  {
    id: 'payroll-001',
    status: 'processed',
    employee: {
      id: 'emp-001',
      name: 'João Silva'
    },
    period: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-31')
    },
    grossSalary: {
      amount: 5000,
      currency: 'USD'
    },
    deductions: [
      {
        type: 'tax',
        amount: {
          amount: 500,
          currency: 'USD'
        },
        description: 'Imposto de Renda Federal'
      },
      {
        type: 'insurance',
        amount: {
          amount: 200,
          currency: 'USD'
        },
        description: 'Seguro de Saúde'
      }
    ],
    netSalary: {
      amount: 4300,
      currency: 'USD'
    },
    payable: {
      id: 'payable-001',
      name: 'Conta Bancária Principal'
    },
    notes: 'Folha de pagamento de janeiro de 2024 processada com sucesso',
    documents: [
      {
        id: 'doc-001',
        name: 'Contracheque de Janeiro de 2024',
        type: 'application/pdf',
        size: 1024000,
        path: '/documents/payroll/payslip-001.pdf',
        url: 'https://example.com/documents/payroll/payslip-001.pdf',
        uploadedAt: new Date('2024-01-31T10:00:00Z')
      }
    ],
    activityRecords: [
      {
        timestamp: new Date('2024-01-31T10:00:00Z'),
        type: 'created',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      },
      {
        timestamp: new Date('2024-02-01T09:00:00Z'),
        type: 'updated',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      }
    ]
  },
  {
    id: 'payroll-002',
    status: 'pending',
    employee: {
      id: 'emp-002',
      name: 'Maria Silva'
    },
    period: {
      startDate: new Date('2024-02-01'),
      endDate: new Date('2024-02-29')
    },
    grossSalary: {
      amount: 4500,
      currency: 'USD'
    },
    deductions: [
      {
        type: 'tax',
        amount: {
          amount: 450,
          currency: 'USD'
        },
        description: 'Imposto de Renda Federal'
      },
      {
        type: 'loan',
        amount: {
          amount: 300,
          currency: 'USD'
        },
        description: 'Pagamento de Empréstimo Estudantil'
      }
    ],
    netSalary: {
      amount: 3750,
      currency: 'USD'
    },
    notes: 'Folha de pagamento de fevereiro de 2024 pendente de aprovação',
    activityRecords: [
      {
        timestamp: new Date('2024-02-29T14:30:00Z'),
        type: 'created',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      }
    ]
  },
  {
    id: 'payroll-003',
    status: 'rejected',
    employee: {
      id: 'emp-003',
      name: 'Miguel Johnson'
    },
    period: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-31')
    },
    grossSalary: {
      amount: 6000,
      currency: 'USD'
    },
    deductions: [
      {
        type: 'tax',
        amount: {
          amount: 600,
          currency: 'USD'
        },
        description: 'Imposto de Renda Federal'
      },
      {
        type: 'other',
        amount: {
          amount: 100,
          currency: 'USD'
        },
        description: 'Penalidade por chegada tardia'
      }
    ],
    netSalary: {
      amount: 5300,
      currency: 'USD'
    },
    notes: 'Rejeitado devido ao cálculo incorreto de deduções',
    activityRecords: [
      {
        timestamp: new Date('2024-01-31T16:00:00Z'),
        type: 'created',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      },
      {
        timestamp: new Date('2024-02-01T11:00:00Z'),
        type: 'updated',
        performedBy: {
          id: 'user-002',
          displayName: 'Usuário Gerente'
        }
      }
    ]
  },
  {
    id: 'payroll-004',
    status: 'processed',
    employee: {
      id: 'emp-004',
      name: 'Sara Wilson'
    },
    period: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-31')
    },
    grossSalary: {
      amount: 5500,
      currency: 'USD'
    },
    deductions: [
      {
        type: 'tax',
        amount: {
          amount: 550,
          currency: 'USD'
        },
        description: 'Imposto de Renda Federal'
      },
      {
        type: 'insurance',
        amount: {
          amount: 250,
          currency: 'USD'
        },
        description: 'Seguro Odontológico'
      }
    ],
    netSalary: {
      amount: 4700,
      currency: 'USD'
    },
    payable: {
      id: 'payable-002',
      name: 'Conta de União de Crédito'
    },
    notes: 'Folha de pagamento de janeiro de 2024 com dedução de seguro odontológico',
    activityRecords: [
      {
        timestamp: new Date('2024-01-31T12:00:00Z'),
        type: 'created',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      },
      {
        timestamp: new Date('2024-02-01T08:30:00Z'),
        type: 'updated',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      }
    ]
  },
  {
    id: 'payroll-005',
    status: 'pending',
    employee: {
      id: 'emp-005',
      name: 'David Brown'
    },
    period: {
      startDate: new Date('2024-02-01'),
      endDate: new Date('2024-02-29')
    },
    grossSalary: {
      amount: 4800,
      currency: 'USD'
    },
    deductions: [
      {
        type: 'tax',
        amount: {
          amount: 480,
          currency: 'USD'
        },
        description: 'Imposto de Renda Federal'
      }
    ],
    netSalary: {
      amount: 4320,
      currency: 'USD'
    },
    notes: 'Folha de pagamento de fevereiro de 2024 - novo funcionário',
    activityRecords: [
      {
        timestamp: new Date('2024-02-29T15:45:00Z'),
        type: 'created',
        performedBy: {
          id: 'user-001',
          displayName: 'Usuário Administrador'
        }
      }
    ]
  },
  {
    id: 'payroll-006',
    status: 'processed',
    employee: {
      id: 'emp-006',
      name: 'Miguel Johnson'
    },
    period: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-31')
    },
    grossSalary: { amount: 5200, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 520, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 200, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4480, currency: 'USD' },
    payable: { id: 'payable-003', name: 'Conta Bancária Principal' },
    notes: 'Folha de pagamento de janeiro de 2024 processada',
    activityRecords: [
      { timestamp: new Date('2024-01-31T10:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-007',
    status: 'pending',
    employee: {
      id: 'emp-007',
      name: 'Lisa Davis'
    },
    period: {
      startDate: new Date('2024-02-01'),
      endDate: new Date('2024-02-29')
    },
    grossSalary: { amount: 5800, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 580, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 250, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4970, currency: 'USD' },
    notes: 'Folha de pagamento de fevereiro de 2024 - posição de gerente',
    activityRecords: [
      { timestamp: new Date('2024-02-29T16:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-008',
    status: 'rejected',
    employee: {
      id: 'emp-008',
      name: 'Roberto Taylor'
    },
    period: {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-31')
    },
    grossSalary: { amount: 4600, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 460, currency: 'USD' }, description: 'Imposto de Renda Federal' }
    ],
    netSalary: { amount: 4140, currency: 'USD' },
    notes: 'Folha de pagamento de janeiro de 2024 - rejeitada devido a horas incorretas',
    activityRecords: [
      { timestamp: new Date('2024-01-31T11:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } },
      { timestamp: new Date('2024-02-01T09:00:00Z'), type: 'updated', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-009',
    status: 'processed',
    employee: {
      id: 'emp-009',
      name: 'Maria Garcia'
    },
    period: {
      startDate: new Date('2024-02-01'),
      endDate: new Date('2024-02-29')
    },
    grossSalary: { amount: 4200, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 420, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 180, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 3600, currency: 'USD' },
    payable: { id: 'payable-004', name: 'Conta de União de Crédito' },
    notes: 'Folha de pagamento de fevereiro de 2024 processada com sucesso',
    activityRecords: [
      { timestamp: new Date('2024-02-29T14:30:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-010',
    status: 'pending',
    employee: {
      id: 'emp-010',
      name: 'Jaime Wilson'
    },
    period: {
      startDate: new Date('2024-03-01'),
      endDate: new Date('2024-03-31')
    },
    grossSalary: { amount: 5400, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 540, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 220, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4640, currency: 'USD' },
    notes: 'Folha de pagamento de março de 2024 - pendente de aprovação',
    activityRecords: [
      { timestamp: new Date('2024-03-31T17:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-011',
    status: 'processed',
    employee: {
      id: 'emp-011',
      name: 'Sara Johnson'
    },
    period: {
      startDate: new Date('2024-03-01'),
      endDate: new Date('2024-03-31')
    },
    grossSalary: { amount: 4800, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 480, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 200, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4120, currency: 'USD' },
    payable: { id: 'payable-005', name: 'Conta Bancária Principal' },
    notes: 'Folha de pagamento de março de 2024 processada com sucesso',
    activityRecords: [
      { timestamp: new Date('2024-03-31T15:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-012',
    status: 'pending',
    employee: {
      id: 'emp-012',
      name: 'Miguel Brown'
    },
    period: {
      startDate: new Date('2024-04-01'),
      endDate: new Date('2024-04-30')
    },
    grossSalary: { amount: 5200, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 520, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 220, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4460, currency: 'USD' },
    notes: 'Folha de pagamento de abril de 2024 - pendente de aprovação',
    activityRecords: [
      { timestamp: new Date('2024-04-30T16:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-013',
    status: 'rejected',
    employee: {
      id: 'emp-013',
      name: 'Emilia Davis'
    },
    period: {
      startDate: new Date('2024-04-01'),
      endDate: new Date('2024-04-30')
    },
    grossSalary: { amount: 4400, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 440, currency: 'USD' }, description: 'Imposto de Renda Federal' }
    ],
    netSalary: { amount: 3960, currency: 'USD' },
    notes: 'Folha de pagamento de abril de 2024 - rejeitada devido a documentação faltante',
    activityRecords: [
      { timestamp: new Date('2024-04-30T14:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } },
      { timestamp: new Date('2024-05-01T10:00:00Z'), type: 'updated', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-014',
    status: 'processed',
    employee: {
      id: 'emp-014',
      name: 'David Wilson'
    },
    period: {
      startDate: new Date('2024-05-01'),
      endDate: new Date('2024-05-31')
    },
    grossSalary: { amount: 5600, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 560, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 250, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4790, currency: 'USD' },
    payable: { id: 'payable-006', name: 'Conta de União de Crédito' },
    notes: 'Folha de pagamento de maio de 2024 processada com sucesso',
    activityRecords: [
      { timestamp: new Date('2024-05-31T13:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-015',
    status: 'pending',
    employee: {
      id: 'emp-015',
      name: 'Jennifer Lee'
    },
    period: {
      startDate: new Date('2024-05-01'),
      endDate: new Date('2024-05-31')
    },
    grossSalary: { amount: 4600, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 460, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 200, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 3940, currency: 'USD' },
    notes: 'Folha de pagamento de maio de 2024 - pendente de aprovação',
    activityRecords: [
      { timestamp: new Date('2024-05-31T17:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-016',
    status: 'processed',
    employee: {
      id: 'emp-016',
      name: 'Cristóbal Martínez'
    },
    period: {
      startDate: new Date('2024-06-01'),
      endDate: new Date('2024-06-30')
    },
    grossSalary: { amount: 5000, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 500, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 220, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4280, currency: 'USD' },
    payable: { id: 'payable-007', name: 'Conta Bancária Principal' },
    notes: 'Folha de pagamento de junho de 2024 processada com sucesso',
    activityRecords: [
      { timestamp: new Date('2024-06-30T12:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-017',
    status: 'rejected',
    employee: {
      id: 'emp-017',
      name: 'Amanda Taylor'
    },
    period: {
      startDate: new Date('2024-06-01'),
      endDate: new Date('2024-06-30')
    },
    grossSalary: { amount: 4200, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 420, currency: 'USD' }, description: 'Imposto de Renda Federal' }
    ],
    netSalary: { amount: 3780, currency: 'USD' },
    notes: 'Folha de pagamento de junho de 2024 - rejeitada devido a cálculos incorretos',
    activityRecords: [
      { timestamp: new Date('2024-06-30T15:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } },
      { timestamp: new Date('2024-07-01T09:00:00Z'), type: 'updated', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-018',
    status: 'pending',
    employee: {
      id: 'emp-018',
      name: 'Kevin Anderson'
    },
    period: {
      startDate: new Date('2024-07-01'),
      endDate: new Date('2024-07-31')
    },
    grossSalary: { amount: 5400, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 540, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 240, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4620, currency: 'USD' },
    notes: 'Folha de pagamento de julho de 2024 - pendente de aprovação',
    activityRecords: [
      { timestamp: new Date('2024-07-31T16:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-019',
    status: 'processed',
    employee: {
      id: 'emp-019',
      name: 'Nicole Garcia'
    },
    period: {
      startDate: new Date('2024-07-01'),
      endDate: new Date('2024-07-31')
    },
    grossSalary: { amount: 4800, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 480, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 200, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4120, currency: 'USD' },
    payable: { id: 'payable-008', name: 'Conta de União de Crédito' },
    notes: 'Folha de pagamento de julho de 2024 processada com sucesso',
    activityRecords: [
      { timestamp: new Date('2024-07-31T14:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  },
  {
    id: 'payroll-020',
    status: 'pending',
    employee: {
      id: 'emp-020',
      name: 'Ryan Thompson'
    },
    period: {
      startDate: new Date('2024-08-01'),
      endDate: new Date('2024-08-31')
    },
    grossSalary: { amount: 5200, currency: 'USD' },
    deductions: [
      { type: 'tax', amount: { amount: 520, currency: 'USD' }, description: 'Imposto de Renda Federal' },
      { type: 'insurance', amount: { amount: 220, currency: 'USD' }, description: 'Seguro de Saúde' }
    ],
    netSalary: { amount: 4460, currency: 'USD' },
    notes: 'Folha de pagamento de agosto de 2024 - pendente de aprovação',
    activityRecords: [
      { timestamp: new Date('2024-08-31T17:00:00Z'), type: 'created', performedBy: { id: 'user-001', displayName: 'Usuário Administrador' } }
    ]
  }
]; 